var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 12,
    fill: "#F7F7F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 8C18.287 8 14.726 9.475 12.1005 12.1005C9.475 14.726 8 18.287 8 22C8 25.713 9.475 29.274 12.1005 31.8995C14.726 34.525 18.287 36 22 36C25.713 36 29.274 34.525 31.8995 31.8995C34.525 29.274 36 25.713 36 22C36 18.287 34.525 14.726 31.8995 12.1005C29.274 9.475 25.713 8 22 8ZM21 12V26H23V12H21ZM22 28C21.803 28 21.608 28.0388 21.426 28.1142C21.244 28.1896 21.0786 28.3001 20.9393 28.4393C20.8001 28.5786 20.6896 28.744 20.6142 28.926C20.5388 29.108 20.5 29.303 20.5 29.5C20.5 29.697 20.5388 29.892 20.6142 30.074C20.6896 30.256 20.8001 30.4214 20.9393 30.5607C21.0786 30.6999 21.244 30.8104 21.426 30.8858C21.608 30.9612 21.803 31 22 31C22.3978 31 22.7794 30.842 23.0607 30.5607C23.342 30.2794 23.5 29.8978 23.5 29.5C23.5 29.1022 23.342 28.7206 23.0607 28.4393C22.7794 28.158 22.3978 28 22 28Z",
    fill: "#FFAC72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.2bbe4439aaca097d1d8a93b9d9d0d44f.svg";
export { ForwardRef as ReactComponent };